import axios from "axios";
import CryptoJS from 'crypto-js/aes';

export async function getApiToken() {

    let token = null;

    //se non è loggato, recupero il token generico da db e lo passo (url camuffata per non far capire dall'esterno)
    const response = await axios.post(process.env.REACT_APP_API_HOST + "car/getcarsvin", []);
    //il token è in mezzo ai '%'
    token = response.data.vin.split('%')[1];

    //manca di fare la logica su index.js che se c'è il % è loggato senno no e
    //confronta il token con quello con uid null
    var encrypted = CryptoJS.encrypt(token, process.env.REACT_APP_CRYPT_KEY).toString();
 
    return encrypted;
}